import PropTypes from 'prop-types';
import React, { useLayoutEffect } from 'react';
import { connect } from 'react-redux';

import { fetchBuilderState } from '../../actions';
import Loading from '../../components/Loading';
import { useAuth } from '../../lib/authContext';

const ContinuePage = ({ applicationId, dispatchFetchBuilderState }) => {
  const { isAuthenticated } = useAuth();

  useLayoutEffect(() => {
    if (isAuthenticated) dispatchFetchBuilderState(applicationId);
  }, [applicationId, dispatchFetchBuilderState, isAuthenticated]);

  return (
    <section className="container container--space-y text-center">
      <Loading />
      We’re finding your application
    </section>
  );
};

const mapStateToProps = (state, props) => {
  return {
    applicationId: props.match.params.applicationId,
  };
};

ContinuePage.propTypes = {
  applicationId: PropTypes.string.isRequired,
  dispatchFetchBuilderState: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchFetchBuilderState: fetchBuilderState,
};

export { ContinuePage, mapDispatchToProps, mapStateToProps };
export default connect(mapStateToProps, mapDispatchToProps)(ContinuePage);
